import { from as observableFrom, Observable, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { Command, CommandBase } from '../../../core/model/command';
import { Router } from '@angular/router';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { Location } from '@angular/common';
import { rentalObjectCommand, RentalObjectMultiselectCommand } from '../../command/rental-object.command';
import { ControlDataExportFile } from '../../model/control-data/control-data-export-file';
import { ControlDataExportCommand } from '../../command/control-data-export.command';
import { ControlDataExportListService } from '../data/control-data-export.service';

@Injectable()
export class GenerateNewControlDataFileCommandHandler implements ICommandHandler {
  constructor(private _service: ControlDataExportListService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === ControlDataExportCommand.generateNewControlDataFile && command.context;
    }
    return false;
  }
  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      this._service.CreateNewControlDataFile(command.context.id).subscribe(value => {});
      return;
    }
  }
}
